import React, { useState, useEffect } from "react";
import { FaHandHoldingHeart } from "react-icons/fa";
import axios from "axios";
import Sendcoins from "../modals/Sendcoins";
import moment from "moment";
import ReactPaginate from "react-paginate";
import EditUserModal from "../modals/EditUser";
import Footer from "../common/Footer";
import OrgLogo from "../../assets/Organization.png";
import IndLogo from "../../assets/Individual.png";
import AdmLogo from "../../assets/Admin.png";
import { MdContentCopy } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoMail } from "react-icons/io5";
import { toast } from 'react-toastify';

const Ngo = () => {
  const userToken = localStorage.getItem("userToken");
  const [userData, setUserData] = useState({});
  const [showSend, setShowSend] = useState(false);
  const openSend = () => setShowSend(true);
  const closeSend = () => setShowSend(false);
  const [currency, setCurrency] = useState({});
  const [filter, setFilter] = useState({ status: "", type: "" });
  const [searchTerm, setSearchTerm] = useState("");
  const [sortByDate, setSortByDate] = useState("desc");
  const [expiry, setExpiry] = useState(0);
  const [showEdit, setShowEdit] = useState(false);
  const openModal = (user) => {
    setShowEdit(true);
  };

  const closeModal = () => {
    setShowEdit(false);
  };

  const [currentPage, setCurrentPage] = useState(0);
  const transactionsPerPage = 10;

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const indexOfLastTransaction = (currentPage + 1) * transactionsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;

  const filteredTransactions = userData?.transactions?.filter(tr =>
    searchTerm === "" ||
    (tr._id && tr._id.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (tr.transId && tr.transId.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (tr.senderId && (tr.senderId.businessName || `${tr.senderId.firstName} ${tr.senderId.lastName}`).toLowerCase().includes(searchTerm.toLowerCase())) ||
    (tr.recipientUserId && (tr.recipientUserId.businessName || `${tr.recipientUserId.firstName} ${tr.recipientUserId.lastName}`).toLowerCase().includes(searchTerm.toLowerCase()))
  ) || [];

  let currentTransactions = filteredTransactions.slice(
    indexOfFirstTransaction,
    indexOfLastTransaction
  );

  const loadExpire = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/expiry`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        let totalAmount = 0;
        response?.data?.upcomingExpiries?.forEach((transaction) => {
          totalAmount += transaction.amount || 0;
        });
        setExpiry(totalAmount);
      })
      .catch(() => {});
  };

  const toggleSortByDate = () => {
    setSortByDate(sortByDate === "asc" ? "desc" : "asc");
  };

  const loadCoin = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/currency`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        setCurrency(response.data[0]);
      })
      .catch(() => {});
  };

  useEffect(() => {
    const loadData = () => {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_LOCAL_API}/dashboard?transactionStatus=${filter.status}&transactionType=${filter.type}`,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };

      axios
        .request(config)
        .then((response) => {
          setUserData(response.data);
        })
        .catch(() => {});
    };
    loadCoin();
    loadData();
    loadExpire();
  }, [filter]);

  const handleDispute = (id) => {
    window.open(`/dispute/${id}`);
  };

  const handleView = (id) => {
    window.open(`/Community/${id}`);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(
      `https://demo.donor.money/register?referredby=${userData?.user?.referCode}`
    );
    toast.success("Copied!", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark"
    })
  };

  const handleMail = () => {
    window.open(
      `mailto:friend@example.com?subject=Donor Money Referral Link&body= Use my Referral Link to create your Donor Money account: https://demo.donor.money/register?referredby=${userData?.user?.referCode}`
    );
  };

  const handleWp = () => {
    window.location.href = `https://wa.me/send?text= Use my Referral Link to create your Donor Money account: https://demo.donor.money/register?referredby=${userData?.user?.referCode}`;
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
    <>
      <div style={{ margin: "100px auto" }}>
        <div style={{ width: "95%", margin: "0 auto 30px auto", display: "flex", gap: "20px", flexWrap: "wrap", alignItems: "stretch" }}>

          {/* User Info Card */}
          <div className="shadow-box" style={{ flex: "1 1 400px", padding: "25px", display: "flex", flexDirection: "column", MINwIDTH: "300px" }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", paddingBottom: "20px", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
              <img className="circular-image"
                src={
                  userData?.user?.profilePic ||
                  (userData?.user?.profileType === "admin"
                    ? AdmLogo
                    : userData?.user?.profileType === "individual"
                      ? IndLogo
                      : OrgLogo)
                }
                alt="profile"
                style={{ height: "70px", width: "70px", objectFit: "cover", borderRadius: "50%", marginRight: "20px", border: "2px solid #3ca151" }}
              />
              <div>
                <h2 style={{ margin: "0 0 5px 0", fontSize: "22px", color: "#fff" }}>
                  {userData?.user?.profileType === "admin" ||
                    userData?.user?.profileType === "individual"
                    ? `${userData?.user?.firstName} ${userData?.user?.lastName}`
                    : userData?.user?.businessName}
                </h2>
                <span style={{
                  display: "inline-block",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  backgroundColor: "rgba(60, 161, 81, 0.2)",
                  color: "#3ca151",
                  fontSize: "12px",
                  fontWeight: "bold",
                  textTransform: "uppercase"
                }}>
                  {userData?.user?.profileType === "impactOrg" ? "IMPACT ORG" : userData?.user?.profileType}
                </span>
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
              <div>
                <div style={{ color: "#aaa", fontSize: "12px", marginBottom: "5px", textTransform: "uppercase", letterSpacing: "1px" }}>Referral Code</div>
                <div style={{ fontSize: "18px", fontWeight: "600", color: "#fff" }}>{userData?.user?.referCode}</div>
              </div>

              {userData?.user?.profileType !== "individual" && (
                <div>
                  <div style={{ color: "#aaa", fontSize: "12px", marginBottom: "5px", textTransform: "uppercase", letterSpacing: "1px" }}>POC Name</div>
                  <div style={{ fontSize: "18px", fontWeight: "600", color: "#fff" }}>{`${userData?.user?.firstName} ${userData?.user?.lastName}`}</div>
                </div>
              )}
            </div>
          </div>

          {/* Referral Link Card */}
          <div className="shadow-box" style={{ flex: "1 1 400px", padding: "25px", display: "flex", flexDirection: "column", justifyContent: "space-between", minWidth: "300px" }}>
            <div>
              <h3 style={{ marginTop: "0", marginBottom: "15px", display: "flex", alignItems: "center", gap: "10px", color: "#fff" }}>
                Share Referral Link
              </h3>

              <div style={{ display: "flex", gap: "10px", marginBottom: "15px", flexWrap: "wrap" }}>
                <div style={{ position: "relative", flex: "1000", minWidth: "200px" }}>
                  <input
                    type="text"
                    disabled
                    value={`https://demo.donor.money/register?referredby=${userData?.user?.referCode}`}
                    style={{ width: "100%", paddingRight: "40px", marginBottom: "0", height: "45px", boxSizing: "border-box" }}
                  />
                  <div style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center" }}>
                    <MdContentCopy onClick={handleCopy} style={{ cursor: "pointer", color: "#3ca151" }} size={20} title="Copy Link" />
                  </div>
                </div>

                <div style={{ display: "flex", gap: "8px" }}>
                  <button onClick={handleMail} style={{ width: "45px", height: "45px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px", background: "rgba(255,255,255,0.1)", border: "none", cursor: "pointer" }}>
                    <IoMail size={22} color="#fff" />
                  </button>
                  <button onClick={handleWp} style={{ width: "45px", height: "45px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px", background: "rgba(37, 211, 102, 0.2)", border: "none", cursor: "pointer", color: "#25D366" }}>
                    <IoLogoWhatsapp size={22} />
                  </button>
                </div>
              </div>
            </div>

            <div style={{ marginTop: "auto", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px", background: "rgba(0,0,0,0.2)", borderRadius: "8px", border: "1px solid rgba(255,255,255,0.05)" }}>
              <span style={{ color: "#aaa", fontSize: "14px", fontWeight: "500" }}>Referral Earnings</span>
              <span style={{ color: "#4caf50", fontWeight: "bold", fontSize: "20px" }}>
                ${(userData?.wallet?.referralEarnings || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
          </div>

        </div>

        {userData?.user?.profileType === "individual" && (
          <div style={{ width: "95%", margin: "0 auto 30px auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "20px" }}>
            <div className="shadow-box" style={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "14px", color: "#aaa", marginBottom: "5px", textTransform: "uppercase" }}>Total Donations</span>
              <span style={{ fontSize: "24px", fontWeight: "bold", color: "#fff" }}>
                {(userData?.transactions?.filter(t => t.senderId?._id === userData?.user?._id && t.transactionType === 'Donation').reduce((sum, t) => sum + (t.amount || 0), 0) || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} DM
              </span>
            </div>
            <div className="shadow-box" style={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "14px", color: "#aaa", marginBottom: "5px", textTransform: "uppercase" }}>Total Received</span>
              <span style={{ fontSize: "24px", fontWeight: "bold", color: "#fff" }}>
                {(userData?.transactions?.filter(t => t.recipientUserId?._id === userData?.user?._id).reduce((sum, t) => sum + (t.amount || 0), 0) || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} DM
              </span>
            </div>
            <div className="shadow-box" style={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "14px", color: "#aaa", marginBottom: "5px", textTransform: "uppercase" }}>Total Referrals</span>
              <span style={{ fontSize: "24px", fontWeight: "bold", color: "#fff" }}>
                {userData?.user?.referralCount || 0}
              </span>
            </div>
            <div className="shadow-box" style={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "14px", color: "#aaa", marginBottom: "5px", textTransform: "uppercase" }}>Total Earned</span>
              <span style={{ fontSize: "24px", fontWeight: "bold", color: "#4caf50" }}>
                ${(userData?.wallet?.referralEarnings || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
          </div>
        )}

        <div className="shadow-box account-box" style={{ width: "95%" }}>
          <div className="account-details">
            {userData?.user?.profileType === "individual" ? (
              <div style={{ marginBottom: "10px" }}>
                <h3
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    textShadow: "0 0 5px rgba(255, 255, 255, 0.3)",
                    marginBottom: "5px",
                  }}
                >
                  Balance: ${" "}
                  {(
                    userData?.wallet?.walletPoint * currency?.value
                  )?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </h3>
                <div
                  style={{ fontSize: "14px", color: "grey", opacity: 0.8, cursor: "help" }}
                  title={`1.000 Donor Money = $${currency?.value?.toFixed(2)} USD`}
                >
                  (1.000 DM = ${currency?.value?.toFixed(2)})
                </div>
              </div>
            ) : (
              <h3>
                Balance: ${" "}
                {(
                  userData?.wallet?.walletPoint * currency?.value
                )?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                <span id="today">
                  (1.000 DM = ${currency?.value?.toFixed(2)}){" "}
                  {
                    //<a id="today" href='/currency'>Price History</a>
                  }
                </span>
              </h3>
            )}
            <h3>
              No. of DM:{" "}
              {userData?.wallet?.walletPoint?.toLocaleString(undefined, {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              })}
            </h3>
            {expiry <= 0 && <h5>No scheduled transfers in the next 30 days.</h5>}
            {expiry > 0 && (
              <h5>
                Note : Your{" "}
                {expiry.toLocaleString(undefined, {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3,
                })}{" "}
                DM will auto transfer in 10 Days
              </h5>
            )}
          </div>
          <div className="action-buttons">
            <button
              onClick={openSend}
              className={userData?.user?.profileType === "individual" ? "dashboard-donate-btn" : ""}
            >
              {userData?.user?.profileType === "individual" && (
                <>💸 Donate {` `}</>
              )}
              {userData?.user?.profileType !== "individual" && <>Send {` `}</>}
              DM
            </button>
            <Sendcoins
              showModal={showSend}
              closeModal={closeSend}
              userToken={userToken}
            />

            <button
              onClick={openModal}
              className={userData?.user?.profileType === "individual" ? "dashboard-edit-btn" : ""}
            >
              Edit Profile
            </button>
            <EditUserModal
              userId={userData.user?._id}
              userToken={userToken}
              onClose={closeModal}
              showEdit={showEdit}
              isAdmin={false}
            />
          </div>
        </div>

        <h3 style={{ textAlign: "center" }}>Recent Transactions</h3>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "start",
          }}
        >
          <div className="shadow-box" style={{ width: "95%" }}>
            <div className="filters-container" style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "15px",
              padding: "15px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: "12px",
              backgroundColor: "rgba(255, 255, 255, 0.02)",
              marginBottom: "20px"
            }}>
              <div className="search-box" style={{ flexGrow: 1, minWidth: "200px" }}>
                <input
                  type="text"
                  placeholder="Search by ID or User..."
                  style={{
                    width: "100%",
                    padding: "0 12px",
                    height: "40px",
                    borderRadius: "6px",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    background: "rgba(0, 0, 0, 0.2)",
                    color: "#fff",
                    fontSize: "14px",
                    marginBottom: "0",
                    boxSizing: "border-box"
                  }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
                <select
                  style={{
                    padding: "0 12px",
                    height: "40px",
                    boxSizing: "border-box",
                    borderRadius: "6px",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    background: "rgba(0, 0, 0, 0.2)",
                    color: "#fff",
                    fontSize: "14px",
                    cursor: "pointer",
                    lineHeight: "normal",
                    margin: "0",
                    verticalAlign: "middle",
                    fontFamily: "inherit"
                  }}
                  onChange={(e) =>
                    setFilter({ ...filter, status: e.target.value })
                  }
                >
                  <option value="">Status</option>
                  <option value="success">Success</option>
                  <option value="failed">Failed</option>
                  <option value="reversed">Reversed</option>
                </select>

                <select
                  style={{
                    padding: "0 12px",
                    height: "40px",
                    boxSizing: "border-box",
                    borderRadius: "6px",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    background: "rgba(0, 0, 0, 0.2)",
                    color: "#fff",
                    fontSize: "14px",
                    cursor: "pointer",
                    lineHeight: "normal",
                    margin: "0",
                    verticalAlign: "middle",
                    fontFamily: "inherit"
                  }}
                  onChange={(e) =>
                    setFilter({ ...filter, type: e.target.value })
                  }
                >
                  <option value="">Type</option>

                  {(userData?.user?.profileType === "ngo" ||
                    userData?.user?.profileType === "impactOrg") && (
                      <>
                        <option value="Grant">Grant</option>
                        <option value="Sale">Sale</option>
                        <option value="Sale on Credit">Sale on Credit</option>
                      </>
                    )}
                  {(userData?.user?.profileType === "individual" ||
                    userData?.user?.profileType === "business") && (
                      <option value="Donation">Donation</option>
                    )}
                  <option value="Barter">Barter</option>
                  <option value="Gift">Gift</option>
                </select>

                <button
                  type="button"
                  style={{
                    padding: "0 12px",
                    height: "40px",
                    boxSizing: "border-box",
                    borderRadius: "6px",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    background: "rgba(0, 0, 0, 0.2)",
                    color: "#fff",
                    fontSize: "14px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                    lineHeight: "normal",
                    outline: "none",
                    margin: "0",
                    verticalAlign: "middle",
                    fontFamily: "inherit"
                  }}
                  onClick={toggleSortByDate}
                >
                  Sort by Date {sortByDate === "asc" ? "↓" : "↑"}
                </button>
              </div>
            </div>
            <div className="table">
              {userData?.user?.profileType === "individual" &&
                (!userData?.transactions || userData?.transactions?.length === 0) ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "40px",
                    color: "rgba(255, 255, 255, 0.6)",
                  }}
                >
                  <FaHandHoldingHeart size={60} style={{ marginBottom: "20px", opacity: 0.8 }} />
                  <h3 style={{ marginBottom: "10px", color: "#fff" }}>No transactions yet</h3>
                  <p style={{ marginBottom: "20px" }}>
                    Start by donating or sharing your referral link.
                  </p>
                  <button onClick={openSend}>Donate Now</button>
                </div>
              ) : (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th style={{ minWidth: "120px" }}>Date</th>
                        <th>Id</th>
                        <th>From</th>
                        <th>To</th>
                        <th> No. of DM</th>
                        <th>Market Value</th>
                        <th>Transaction Type</th>
                        <th>Transaction Status</th>
                        <th>Payment Mode</th>
                        <th>Support</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentTransactions
                        ?.sort((a, b) => {
                          const dateA = moment(a.createdDate);
                          const dateB = moment(b.createdDate);
                          return sortByDate === "asc"
                            ? dateA - dateB
                            : dateB - dateA;
                        })
                        .map((tr, index) => (
                          <tr key={index}>
                            <td>
                              {moment(tr.createdDate).format("DD-MMM-YYYY")}
                              <br />
                              {moment(tr.createdDate).format("hh:mm A")}
                            </td>
                            <td>{tr.transId ? tr.transId : tr._id}</td>
                            <td
                              style={{ cursor: "pointer" }}
                              onClick={() => handleView(tr.senderId?.userName)}
                            >
                              {tr.senderId?.businessName
                                ? tr.senderId?.businessName
                                : `${tr.senderId?.firstName} ${tr.senderId?.lastName}`}
                            </td>
                            <td
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleView(tr.recipientUserId?.userName)
                              }
                            >
                              {tr.recipientUserId?.businessName
                                ? tr.recipientUserId?.businessName
                                : `${tr.recipientUserId?.firstName} ${tr.recipientUserId?.lastName}`}
                            </td>
                            <td>
                              {tr.amount?.toLocaleString(undefined, {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3,
                              })}
                            </td>
                            <td>
                              $
                              {(tr.amount * tr.currencyValue)?.toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              ) || 0}
                            </td>
                            <td>{tr.transactionType}</td>
                            <td>{capitalizeFirstLetter(tr.transactionStatus)}</td>
                            <td>{tr.paymentMode}</td>
                            <td>
                              {" "}
                              <button onClick={() => handleDispute(tr._id)}>
                                Get Support
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={Math.ceil(
                      filteredTransactions?.length / transactionsPerPage
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                </>
              )}
            </div>
          </div>
        </div>
        <p style={{ textAlign: "center" }}>
          *Market Value is based on the last traded price on the Donor Money
          &nbsp;{" "}
          <a href="https://www.donor.money/Impact-Exchange ">
            Impact Funding Exchange
          </a>
        </p>
      </div>

      <Footer />
    </>
  );
};

export default Ngo;
